// Mini Basket Style
function hideBasket() {
    $("body").removeClass("BasketDropped");
    $("body").removeClass("no-scroll");
    $(".SepetProducts").removeClass("open");
}

function setContentHeight() {
    if (isMobileResolution()) {
        $(".SepetProducts .BasketContainer .BasketCenterContent").height($(window).height() - $(".PriceAndButton").height() - $(".CartTitle").height() - 10);
    }
    else {
        $(".SepetProducts").css("top", ($("header").height() + 1) + "px");
        //$(".SepetProducts").height($(window).height() - $("header").height());

        $(".SepetProducts .BasketContainer .BasketCenterContent").height($(window).height() - $(".PriceAndButton").height() - $("header").height() - $(".CartTitle").height() - 10);
    }
}

function toggleBasket() {
    if ($(".SepetProducts").hasClass("open")) {
        $(".SepetProducts").removeClass("open");
        $("body").removeClass("BasketDropped").removeClass("BackDropped");
        $("body").removeClass("no-scroll");
    }
    else {
        $(".SepetProducts").addClass("open");
        $("body").addClass("BasketDropped");
        $("body").addClass("no-scroll");

        setContentHeight();
    }
}
// End Mini Basket Style

// Mini Basket Operations
function RemoveFromCardForMiniCard(id, langId, allRemove) {
    basketElement = $("#UserMenus .SepetProducts .BasketContainer");
    GenerateLocalLoading(basketElement, "show");

    $.ajax({
        type: 'get',
        url: getRequestRoute() + '/p/Cart/RemoveFromCart' + getLandingParameter(),
        data: 'id=' + id + "&langID=" + langId + allRemove,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                //$.ajax({
                //    type: 'get',
                //    url: getRequestRoute() + "/p/Cart/GetSepetIcerik" + getLandingParameter(),
                //    data: "",
                //    async: false,
                //    contentType: "application/json; charset=utf-8",
                //    dataType: 'text',
                //    success: function (dt) {
                //        $("#UserMenus  #UserAndBasket").html(dt);
                //        toggleBasket();
                //        setContentHeight();
                //    },
                //    error: function () {
                //        GenerateLocalLoading(basketElement, "hide");
                //    }
                //});

                GetSepetIcerik(function (dt) {
                    $("#UserMenus  #UserAndBasket").html(dt);
                    toggleBasket();
                    setContentHeight();

                    GenerateLocalLoading(basketElement, "hide");
                });
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
            }
        },
        error: function () {
            GenerateLocalLoading(basketElement, "hide");
        }
    });
}

function GetSepetIcerik(callback) {
    $.ajax({
        type: 'get',
        url: getRequestRoute() + "/p/Cart/GetSepetIcerik" + getLandingParameter(),
        data: "",
        async: true,
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: 'text',
        success: function (dt) {
            callback(dt);
        }
    });
}
// End Mini Basket Operations

// Product List

// End Product List


function UserForms(form, callback) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action") + getLandingParameter(),
        data: form.serialize(),
        dataType: "json",
        cache: false,
        success: function (dt) {
            callback(dt);
        },
        error: function () {
            callback(getStandartMessages("BirHataOlustu"));
        }
    });
}